import React from 'react';
import RemovePackageItemButtonProperties from "./RemovePackageItemButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';

const RemovePackageItemButton: React.FC<RemovePackageItemButtonProperties> = ({
                                                                                  onClick = () => {},
                                                                                  onSave = () => {},
                                                                                  showIcon = true,
                                                                                  showText = true,
                                                                                  disabled,
                                                                                  className = '',
                                                                                  packageItem,
                                                                                  categoryId,
                                                                                  onRemovePackageItem,
                                                                                  rounded = false,
                                                                                  size = ButtonSize.DEFAULT,
                                                                                  type = ButtonType.DEFAULT
}) => {

    const i18n = useI18nContext();
    const confirm = useConfirmation();

    const handleOnclick = async () => {
        onClick();
        const success = await confirm(i18n.translate("REMOVE_PACKAGE_ITEM_CONFIRMATION"), '');
        if (success) {
            onRemovePackageItem(packageItem,categoryId)
            if (onSave) {
                onSave();
            }
        }
    }

    const text = i18n.translate("REMOVE_PACKAGE_ITEM");

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <Btn/>
        )}
    </Observer>
}

export default RemovePackageItemButton;
